<!--
 * @Descripttion: 超链接设置
 * @Author: zenghua.wang
 * @Date: 2021-10-13 17:01:16
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-11-04 16:37:25
-->
<template>
  <el-collapse-item :title="title">
    <el-form-item label="显示">
      <el-switch
        v-model="data.option.isLink"
        :active-color="theme.active"
        :inactive-color="theme.inactive"
      />
    </el-form-item>

    <template v-if="data.option.isLink">
      <!-- <el-form-item label="打开方式">
          <el-radio-group
            v-model="data.option.target"
            size="mini"
          >
            <el-radio-button
              v-for="(item,index) in openList"
              :key="item.label"
              :value="item.value"
              :label="item.label"
            ></el-radio-button>
          </el-radio-group>
        </el-form-item> -->

      <el-form-item label="链接地址">
        <el-input
          v-model="data.option.url"
          :type="type"
          :rows="4"
          :placeholder="placeholder"
        />
      </el-form-item>
      <div
        v-if="showTips"
        class="xa-form-tips"
      >备注: {{tips}}</div>
    </template>
  </el-collapse-item>
</template>

<script>
import { theme } from '@/dragComponents/model/default.js'
export default {
  name: 'config-link',
  props: {
    title: {
      type: String,
      default: '超链接设置'
    },
    data: {
      type: [Array, Object]
    },
    type: {
      type: String,
      default: 'textarea'
    },
    placeholder: {
      type: String,
      default: '如：http://www.wiseloong.com?id=${id}&name=${name}'
    },
    showTips: {
      type: Boolean,
      default: true
    },
    tips: {
      type: String,
      default: '输入完整(http://www.xxx)的地址可以在新窗口中打开！'
    }
  },
  data() {
    return {
      theme: theme,
      openList: [
        {
          label: '新窗口',
          value: '_bank'
        },
        {
          label: '当前窗口',
          value: '_self'
        }
      ]
    }
  }
}
</script>
